import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'



import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant);

import "@/styles/index.scss"

//微信
 import wx from "weixin-js-sdk";
 Vue.prototype.wx = wx
//Vue.use(wx);



Vue.config.productionTip = false
console.log(process.env.NODE_ENV)

// 设置登录过期时间（一天）*30
let EXPIRESTIME = 86400000*30
//路由守卫
router.beforeEach((to,from,next)=>{
  if (to.meta.needLogin) {
      //页面是否登录，本地存储中是否有token(uid)数据，否：跳转登录页面
      let item = localStorage.getItem("token");
      try {
          item = JSON.parse(item);
      } catch (error) {
          // eslint-disable-next-line no-self-assign
          item = item;
      }
      if (item) {
        let date = new Date().getTime();
        // 如果大于就是过期了，如果小于或等于就还没过期
        if (date - item.startTime > EXPIRESTIME) {
            localStorage.removeItem('token');
            next({
              name: "/login"
            });
        } else {
          next();
        }
      } else {
        next({
          name: "/login"
        });
      }
    } else {
      next();
    }
	
  if(to.meta.title){
    document.title = to.meta.title
  }
  if(to.matched.length===0){
    from.name ? next({
      name:from.name
    }):next('/errorinfo')
  }else{
    next()
  }
 
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
